import React from 'react';
import {
  ComputerDesktopIcon,
  CursorArrowRaysIcon,
  DevicePhoneMobileIcon,
} from '@heroicons/react/20/solid';
import { PlatformTypes } from '../../../../data/enums';
import { platformsFromCsv } from '../../lib/campaign-body';

// The live app's platform icons (handoff §5: "do not redraw them"), as
// today's Coupons table drew them: Kiosk ComputerDesktop, Online/QR
// CursorArrowRays, Mobile DevicePhoneMobile. Always in this order.
export const CHANNELS = [
  { value: '0', label: PlatformTypes[0], Icon: ComputerDesktopIcon },
  { value: '10', label: PlatformTypes[10], Icon: CursorArrowRaysIcon },
  { value: '20', label: PlatformTypes[20], Icon: DevicePhoneMobileIcon },
];

// 26×26 tiles on #F1F3F7 (fin-hair), radius 6, 6px apart; a 14px icon in
// #3C4A68 (fin-ink-2); the tooltip is the channel's name.
const ChannelIcons = ({ platforms }) => {
  const on = platformsFromCsv(platforms);
  return (
    <div className="flex items-center gap-1.5">
      {CHANNELS.filter((channel) => on.includes(channel.value)).map(({ value, label, Icon }) => (
        <span
          key={value}
          role="img"
          aria-label={label}
          title={label}
          className="inline-flex h-[26px] w-[26px] items-center justify-center rounded-md bg-fin-hair text-fin-ink-2"
        >
          <Icon className="h-3.5 w-3.5" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
};

export default ChannelIcons;
